import React from "react";
import clsx from "clsx";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Typography, Button } from "@material-ui/core";
import { calculateTotal } from "../../common/packagingConfig";
import {
  buildPackageDetailsRenderItems,
  renderPackageDetailsField,
} from "./packageDetailsRenderUtils";

const PackageDetails = ({
  classes,
  editInfo,
  errorInfo,
  packageTypeList,
  handleChange,
  addItem,
  packagingConfig,
}) => {
  const { miscellaneous, fieldOrder } = packagingConfig;
  const { addItem: addItemCfg, total } = miscellaneous;
  const groupTarget = addItemCfg?.groupTarget;

  const renderItems = buildPackageDetailsRenderItems({
    fieldOrder,
    packagingConfig,
    packagingItems: editInfo.packagingItems,
  });

  return (
    <div id="packageDetails" className={classes.packageDetailsSection}>
      <Typography variant="subtitle1" className={classes.headerLabel}>
        PACKAGING DETAILS
      </Typography>
      <div className={classes.packageFieldsGrid}>
        {renderItems.map((item) => (
          <div
            key={item.key}
            className={clsx(
              classes.packageFieldCell,
              item.fieldConfig?.fullWidth && classes.packageFieldCellFullWidth
            )}
          >
            {renderPackageDetailsField({
              item,
              groupTarget,
              handleChange,
              errorInfo,
              editInfo,
              packageTypeList,
            })}
          </div>
        ))}
      </div>
      {total.visible && (
        <Typography variant="body2" className={classes.totalText}>
          {total.label}: {calculateTotal(editInfo, total.sourceFields)}
        </Typography>
      )}
      {addItemCfg.visible && (
        <Button
          autoFocus
          color="primary"
          variant="outlined"
          className={classes.actionButton}
          onClick={addItem}
        >
          add item
        </Button>
      )}
    </div>
  );
};

export default withStyles(styles)(PackageDetails);
